import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import ReactTooltip from 'react-tooltip'

import CommentCountIndicator from '../../mini/comments/CommentCountIndicator'
import DraftCommentIndicator from '../../mini/comments/DraftCommentIndicator'

import {
  getCssClasses,
  isRequiredSection,
  getSectionCommentCount,
  hasSectionDraftComments
} from '../../../utils/questmenuitem'
import { questHasContentWarnings } from '../../../utils/contentwarnings'

class QuestMenuItem extends Component {
  constructor(props) {
    super(props)
    this.onClickBound = this.onClick.bind(this)
  }

  render() {
    const {
      comments,
      layout,
      text,
      isComplete,
      section,
      reviewStatus,
      draftComments
    } = this.props
    var commentCount
    var cssClasses = getCssClasses(section, layout, reviewStatus)

    if (isComplete) {
      cssClasses += ' complete'
    } else if (isComplete !== undefined && !isComplete) {
      cssClasses += ' incomplete'
    }

    if (comments) {
      commentCount = getSectionCommentCount(comments, layout)
    }

    return (
      <li
        data-layout={layout}
        className={cssClasses}
        onClick={this.onClickBound}
      >
        <div className="label-container">
          <label>{text}</label>
          {isRequiredSection(layout) && <div className="requiredtool" />}
          {questHasContentWarnings(this.props.quest) &&
            layout === 'basicinformation' && (
              <React.Fragment>
                <div
                  className="generic-content-warning"
                  data-for="genericContentWarningQuest"
                  data-tip="This quest contains  content warnings"
                />
                <ReactTooltip
                  id="genericContentWarningQuest"
                  effect={'solid'}
                  offset={{ top: -2 }}
                />
              </React.Fragment>
            )}
        </div>
        <div className="draft-comment-indicator-container">
          {draftComments && hasSectionDraftComments(draftComments, layout) && (
            <DraftCommentIndicator />
          )}
        </div>
        <div className="comment-count-indicator-container">
          {commentCount > 0 && (
            <CommentCountIndicator commentCount={commentCount} />
          )}
        </div>
      </li>
    )
  }

  onClick(e) {
    const _el = e.currentTarget
    const layout = _el.getAttribute('data-layout')
    this.props.dispatch(push(`/quest/${this.props.quest.id}/${layout}`))
  }
}

QuestMenuItem.propTypes = {
  comments: PropTypes.array,
  dispatch: PropTypes.func.isRequired,
  layout: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  isComplete: PropTypes.bool,
  reviewStatus: PropTypes.string,
  section: PropTypes.string,
  quest: PropTypes.object,
  draftComments: PropTypes.array
}

export const mapStateToProps = state => ({
  comments: state.quest.comments,
  section: state.quest.section,
  quest: state.quest.item,
  draftComments: state.quest.userComments
})

export default connect(mapStateToProps)(QuestMenuItem)
export { QuestMenuItem as QuestMenuItemDisconnected } // pure component - used in tests



// WEBPACK FOOTER //
// ./src/components/quest/menu/QuestMenuItem.js